<template>
    <v-app>
        <v-container>
            <v-row>
                <h3>Crear Rol</h3>
            </v-row>
            <v-row class="mt-5">
                <v-col lg="3" class="text-right bold mr-5">
                    Nombre
                </v-col>
                <v-col lg="6">
                    <v-text-field
                        name="name"
                        label="Nombre del Rol"
                        id="nombre"
                        v-model="role.name"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col lg="12" class="text-center">
                    <v-btn color="info" @click="setData">Guardar</v-btn>
                    <v-btn color="error" class="ml-5" @click="$router.push('/role/')">Cancelar</v-btn>
                </v-col>
                
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return {
            role:{
                name: ''

            }
        }
    },methods:{
        setData: async function(){
            let {data} = await axios.put('https://127.0.0.1:3000/role/',this.role)
            this.$router.push(`/role/${data.id}`)
        }
    }
}
</script>

<style>
    .bold{
        font-weight: bolder
    }
</style>